import React, {useEffect, useState} from "react";
import {Button, Col, Form, Input, message, Modal, Pagination, Row, Select, Space, Table, Badge} from "antd";
import { RemoteImg } from '../component/RemoteMedia';
import {useCookies} from "react-cookie";
import axios from "axios";
import dayjs from "dayjs";
import {useNavigate} from "react-router-dom";
import Paragraph from "antd/es/typography/Paragraph";
import Footer from "../component/Footer";
import { formatCurrency } from '../helper';
import { CrownOutlined, CheckOutlined } from '@ant-design/icons';

export default function Profile() {
    const [cookies] = useCookies(["user"]);
    const [form] = Form.useForm();
    const [profile, setProfile] = useState({});
    const [transfer, setTransfer] = useState([]);
    const [enrolls, setEnrolls] = useState([]);
    const [streak, setStreak] = useState([]);
    const [editProfile, setEditProfile] = useState(false);
    const [pricePackage, setPricePackage] = useState("");
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [pagination, setPagination] = useState({
        page: 1,
        pageSize: 8,
    });

    const fetchTransfer = async () => {
        await axios
            .get(
                `${process.env.REACT_APP_API_URL}/transfer/getByIdUser/${cookies?.user?.id}`, {params: pagination})
            .then((res) => {
                const data = res?.data;
                setTransfer(data);
            });
    };

    const fetchEnrolls = async () => {
        const res = await axios
            .get(
                `${process.env.REACT_APP_API_URL}/enroll`, {
                    params: pagination,
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${cookies?.user?.token}`
                    }
                });
        console.log(res.data)
        setEnrolls(res.data);
    };

    const getUserStreak = async () => {
        await axios.get(
            `${process.env.REACT_APP_API_URL}/user/me`,
            {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${cookies?.user?.token}`
                }
            }
        ).then((res) => {
            const data = res?.data;
            setStreak(data);
        });
    }

    const vip_expire_at = (pricePackage) => {
        const today = new Date();
        if (pricePackage === "80000") {
            const vip_expire_at = new Date(today.getFullYear(), today.getMonth() + 1, today.getDate());
            return dayjs(vip_expire_at).format('YYYY/MM/DD');
        } else if (pricePackage === "600000") {
            const vip_expire_at = new Date(today.getFullYear() + 1, today.getMonth(), today.getDate());
            return dayjs(vip_expire_at).format('YYYY/MM/DD');
        } else if (pricePackage === "1400000") {
            const vip_expire_at = new Date(today.getFullYear() + 5, today.getMonth(), today.getDate());
            return dayjs(vip_expire_at).format('YYYY/MM/DD');
        } else {
            return null;
        }
    }

    const postTransfer = async () => {
        const dataTransfer = {
            transfer_content: cookies?.user?.email,
            transfer_price: pricePackage,
            vip_expire_at: vip_expire_at(pricePackage),
            create_by: cookies?.user?.id
        };

        await axios
            .post(
                `${process.env.REACT_APP_API_URL}/transfer/create`,
                dataTransfer
            )
            .finally(() => {
                message.success("Gửi lệnh chuyển tiền thành công !");
                setIsModalOpen(false);
                fetchTransfer();
            });
    }

    const onSubmit = async (values) => {
        if (values?.passwordNew === values?.comfirmPassword && values?.passwordNew !== undefined) {
            await axios
                .post(
                    `${process.env.REACT_APP_API_URL}/user/update/${cookies?.user?.id}`,
                    values
                )
                .finally(() => {
                    window.location.reload(false);
                    setEditProfile(false);
                    message.success("Cập nhật thông tin thành công !");
                });
        } else {
            message.error("Thông tin điền bị sai hoặc thiếu!");
        }
    };

    const handleProvinceChange = (value) => {
        if (value > 0) {
            return (
                <>
                    {value === "80000" ?
                        <>
                            <p className="pt-5 text-black font-bold text-2xl text-center">Package Vip 1</p>
                            <p className="pt-2 text-black font-semibold text-xl text-center">80.000 VND</p>
                        </>
                        : value === "600000" ?
                            <>
                                <p className="pt-5 text-black font-bold text-2xl text-center">Package Vip 2</p>
                                <p className="pt-2 text-black font-semibold text-xl text-center">600.000 VND</p>
                            </>
                            : value === "1400000" ?
                                <>
                                    <p className="pt-5 text-black font-bold text-2xl text-center">Package Vip 3</p>
                                    <p className="pt-2 text-black font-semibold text-xl text-center">1.400.000 VND</p>
                                </>
                                : <></>
                    }

                    <p className="font-semibold text-lg pb-3">Bank: MB Bank</p>
                    <p className="flex font-semibold text-lg">Content: <Paragraph copyable
                                                                                  className="pl-4 font-semibold text-lg">{cookies?.user?.email}</Paragraph>
                    </p>
                    <p className="flex font-semibold text-lg">Price: <Paragraph copyable
                                                                                className="pl-4 font-semibold text-lg">{value}</Paragraph>
                    </p>

                    <div className="flex justify-center py-5">
                        <img
                            src={`https://img.vietqr.io/image/MB-0336877888-compact.png?amount=${value}&addInfo="${cookies?.user?.email}"`}
                            className="w-[400px]"/>
                    </div>
                </>
            )
        }
    };

    useEffect(() => {
        if (Object.keys(profile)?.length > 0) {
            form.resetFields();
        }
    }, [form, profile]);

    const columns = [
        {
            title: <div>ID</div>,
            key: "transfer_id",
            dataIndex: "transfer_id",
            width: 50,
            render: (_, record) => <div>{record?.transfer_id}</div>,
        },
        {
            title: <div>Nội dung</div>,
            key: "transfer_content",
            dataIndex: "transfer_content",
            width: 160,
            render: (_, record) => <div>{record?.transfer_content}</div>,
        },
        {
            title: <div>Giá</div>,
            key: "transfer_price",
            dataIndex: "transfer_price",
            width: 160,
            render: (_, record) => <div className="font-semibold text-blue-400">{formatCurrency(record?.transfer_price)}</div>,
        },
        {
            title: <div>Trạng thái</div>,
            key: "transfer_status",
            dataIndex: "transfer_status",
            width: 160,
            render: (_, record) => (
                <div>
                    {record?.transfer_status === 1 ?
                        <p className="font-bold text-yellow-500">Đang chờ xác nhận</p>
                        : <p className="font-bold text-green-500">Đã xác nhận</p>
                    }
                </div>
            ),
        },
        {
            title: <div className={"base-table-cell-label "}>Ngày tạo</div>,
            key: "create_at",
            dataIndex: "create_at",
            width: 160,
            render: (_, record) => {
                return (
                    <div>
            <span className={"!inline-block min-w-[100px]"}>
              {dayjs(record?.create_at).format("DD/MM/YYYY")}
            </span>
                    </div>
                );
            },
        }
    ];

    const enrollColumn = [
        {
            title: <div>ID</div>,
            key: "id",
            dataIndex: "id",
            width: 50,
            render: (_, record) => <div>{record?.lesson_id}</div>,
        },
        {
            title: <div>Bài học</div>,
            key: "lesson",
            dataIndex: "lesson",
            width: 160,
            render: (_, record) => <div>{record?.title}</div>,
        },
        {
            title: <div className={"base-table-cell-label "}>Ngày học</div>,
            key: "create_at",
            dataIndex: "create_at",
            width: 160,
            render: (_, record) => {
                return (
                    <div>
            <span className={"!inline-block min-w-[100px]"}>
              {dayjs(record?.update_at).format("DD/MM/YYYY")}
            </span>
                    </div>
                );
            },
        },
        {
            title: <div className={"base-table-cell-label "}>Thời gian học</div>,
            key: "create_at",
            dataIndex: "create_at",
            width: 160,
            render: (_, record) => {
                return (
                    <div>
            <span className={"!inline-block min-w-[100px]"}>
              {dayjs(record?.update_at).format("hh:mm")}
            </span>
                    </div>
                );
            },
        },
        {
            title: <div>Số lần học</div>,
            key: "count",
            dataIndex: "count",
            width: 160,
            render: (_, record) => <div>{record?.count}</div>,
        },
    ];

    useEffect(() => {
        fetchTransfer()
    }, [pagination]);
    useEffect(() => {
        fetchEnrolls();
    }, []);

    useEffect(() => {
        if (cookies?.user) {
            getUserStreak();
        }
    }, [cookies?.user]);

    return (
        <>
            <div className="py-[60px] bg-[#0a1628] min-h-screen">
                <Row justify={"center"} align={"middle"}>
                    <Col
                        lg={20}
                        xs={24}
                        className="p-[20px] border border-white/10 rounded bg-[#0f1e35]"
                    >
                        <Form
                            layout={"vertical"}
                            colon={false}
                            form={form}
                            initialValues={profile}
                            onFinishFailed={(e) => console.log(e)}
                            onFinish={onSubmit}
                        >
                            <Row gutter={20}>
                                <Col>
                                    <RemoteImg src={cookies?.user?.avatar} alt={cookies?.user?.username} className="rounded-full" style={{width:120,height:120}} />
                                </Col>
                                <Col>
                                    <div className="text-[26px] font-medium text-white">
                                        {cookies?.user?.username}
                                    </div>
                                    <div className="text-[18px] font-normal text-gray-400">{cookies?.user?.email}</div>
                                    {streak?.vip_expire_at && new Date(streak?.vip_expire_at) > new Date() && (
                                        <Badge.Ribbon text="VIP Member" color="gold">
                                            <div className="px-4 py-2 mt-4 bg-gradient-to-r from-yellow-600 to-yellow-500 rounded-lg inline-block">
                                                <CrownOutlined className="mr-2" />
                                                <span className="font-semibold">Hết hạn: {dayjs(streak?.vip_expire_at).format("DD/MM/YYYY")}</span>
                                            </div>
                                        </Badge.Ribbon>
                                    )}
                                </Col>
                            </Row>
                            <Row xs={24} lg={12} className="pt-10">
                                {!editProfile ? (
                                    <>
                                        <Form.Item label="Password" className="w-[300px]">
                                            <Input
                                                disabled={!editProfile}
                                                size="large"
                                                placeholder="*********"
                                            />
                                        </Form.Item>
                                    </>
                                ) : (
                                    <>
                                        <Col xs={24} xl={8}>
                                            <Form.Item label="Password New" name="passwordNew" className="w-[300px]">
                                                <Input
                                                    disabled={!editProfile}
                                                    size="large"
                                                    placeholder="*********"
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} xl={8}>
                                            <Form.Item label="Confirm Password" name="comfirmPassword"
                                                       className="w-[300px]">
                                                <Input
                                                    disabled={!editProfile}
                                                    size="large"
                                                    placeholder="*********"
                                                />
                                            </Form.Item>
                                        </Col>
                                    </>
                                )}
                                <Col xs={24}>
                                    <Space>
                                        <Button
                                            type={"primary"}
                                            className="bg-blue-500"
                                            onClick={() => setEditProfile(!editProfile)}
                                        >
                                            Edit profile
                                        </Button>
                                        {editProfile && (
                                            <Button
                                                type={"primary"}
                                                className="bg-blue-500"
                                                htmlType={"submit"}>
                                                Save
                                            </Button>
                                        )}
                                    </Space>
                                </Col>
                            </Row>
                        </Form>
                    </Col>

                    {/* VIP Packages Section - Only show if user is not VIP */}
                    {!(streak?.vip_expire_at && new Date(streak?.vip_expire_at) > new Date()) && (
                    <Col
                        lg={20}
                        xs={24}
                        className="p-[20px] mt-5 border border-white/10 rounded bg-[#0f1e35]"
                    >
                        <p className="font-bold py-5 text-center text-2xl text-white">
                            <CrownOutlined className="mr-2 text-yellow-500" />
                            Nâng cấp tài khoản VIP
                        </p>
                        <p className="text-center text-gray-400 mb-8">Chọn gói phù hợp để truy cập toàn bộ bài học</p>
                        
                        <Row gutter={[24, 24]} justify="center">
                            {/* Package 1 Month */}
                            <Col xs={24} md={8}>
                                <div className="relative bg-gradient-to-br from-[#1a2d4a] to-[#0f1e35] border border-white/20 rounded-2xl p-6 hover:border-blue-500 transition-all duration-300 hover:shadow-xl hover:shadow-blue-500/20">
                                    <div className="text-center">
                                        <div className="inline-block p-4 bg-blue-500/10 rounded-full mb-4">
                                            <CrownOutlined className="text-4xl text-blue-400" />
                                        </div>
                                        <h3 className="text-xl font-bold text-white mb-2">VIP 1 Tháng</h3>
                                        <div className="mb-6">
                                            <span className="text-4xl font-bold text-white">80.000</span>
                                            <span className="text-gray-400 ml-2">VNĐ</span>
                                        </div>
                                        <ul className="text-left space-y-3 mb-6">
                                            <li className="flex items-start text-gray-300">
                                                <CheckOutlined className="text-green-500 mr-2 mt-1" />
                                                <span>Truy cập tất cả bài học</span>
                                            </li>
                                            <li className="flex items-start text-gray-300">
                                                <CheckOutlined className="text-green-500 mr-2 mt-1" />
                                                <span>Học không giới hạn</span>
                                            </li>
                                            <li className="flex items-start text-gray-300">
                                                <CheckOutlined className="text-green-500 mr-2 mt-1" />
                                                <span>Thời hạn: 30 ngày</span>
                                            </li>
                                        </ul>
                                        <Button
                                            type="primary"
                                            size="large"
                                            block
                                            className="bg-blue-500 hover:bg-blue-600 border-none h-12 text-lg font-semibold"
                                            onClick={() => {
                                                setPricePackage("80000");
                                                setIsModalOpen(true);
                                            }}
                                        >
                                            Chọn gói này
                                        </Button>
                                    </div>
                                </div>
                            </Col>

                            {/* Package 1 Year - Most Popular */}
                            <Col xs={24} md={8}>
                                <Badge.Ribbon text="Phổ biến nhất" color="gold" className="text-sm font-semibold">
                                    <div className="relative bg-gradient-to-br from-yellow-600/20 to-yellow-500/10 border-2 border-yellow-500 rounded-2xl p-6 hover:shadow-2xl hover:shadow-yellow-500/30 transition-all duration-300 transform hover:scale-105">
                                        <div className="text-center">
                                            <div className="inline-block p-4 bg-yellow-500/20 rounded-full mb-4">
                                                <CrownOutlined className="text-4xl text-yellow-500" />
                                            </div>
                                            <h3 className="text-xl font-bold text-white mb-2">VIP 1 Năm</h3>
                                            <div className="mb-6">
                                                <span className="text-4xl font-bold text-yellow-500">600.000</span>
                                                <span className="text-gray-400 ml-2">VNĐ</span>
                                                <div className="text-sm text-green-400 mt-1">Tiết kiệm 360.000 VNĐ</div>
                                            </div>
                                            <ul className="text-left space-y-3 mb-6">
                                                <li className="flex items-start text-gray-300">
                                                    <CheckOutlined className="text-yellow-500 mr-2 mt-1" />
                                                    <span>Truy cập tất cả bài học</span>
                                                </li>
                                                <li className="flex items-start text-gray-300">
                                                    <CheckOutlined className="text-yellow-500 mr-2 mt-1" />
                                                    <span>Học không giới hạn</span>
                                                </li>
                                                <li className="flex items-start text-gray-300">
                                                    <CheckOutlined className="text-yellow-500 mr-2 mt-1" />
                                                    <span>Thời hạn: 365 ngày</span>
                                                </li>
                                                <li className="flex items-start text-gray-300">
                                                    <CheckOutlined className="text-yellow-500 mr-2 mt-1" />
                                                    <span className="font-semibold text-yellow-500">Ưu đãi tốt nhất!</span>
                                                </li>
                                            </ul>
                                            <Button
                                                size="large"
                                                block
                                                className="bg-gradient-to-r from-yellow-600 to-yellow-500 hover:from-yellow-500 hover:to-yellow-600 border-none h-12 text-lg font-semibold text-black"
                                                onClick={() => {
                                                    setPricePackage("600000");
                                                    setIsModalOpen(true);
                                                }}
                                            >
                                                Chọn gói này
                                            </Button>
                                        </div>
                                    </div>
                                </Badge.Ribbon>
                            </Col>

                            {/* Package 5 Years */}
                            <Col xs={24} md={8}>
                                <div className="relative bg-gradient-to-br from-purple-600/20 to-purple-500/10 border border-purple-500/50 rounded-2xl p-6 hover:border-purple-500 transition-all duration-300 hover:shadow-xl hover:shadow-purple-500/20">
                                    <div className="text-center">
                                        <div className="inline-block p-4 bg-purple-500/10 rounded-full mb-4">
                                            <CrownOutlined className="text-4xl text-purple-400" />
                                        </div>
                                        <h3 className="text-xl font-bold text-white mb-2">VIP 5 Năm</h3>
                                        <div className="mb-6">
                                            <span className="text-4xl font-bold text-purple-400">1.400.000</span>
                                            <span className="text-gray-400 ml-2">VNĐ</span>
                                            <div className="text-sm text-green-400 mt-1">Tiết kiệm 3.400.000 VNĐ</div>
                                        </div>
                                        <ul className="text-left space-y-3 mb-6">
                                            <li className="flex items-start text-gray-300">
                                                <CheckOutlined className="text-purple-400 mr-2 mt-1" />
                                                <span>Truy cập tất cả bài học</span>
                                            </li>
                                            <li className="flex items-start text-gray-300">
                                                <CheckOutlined className="text-purple-400 mr-2 mt-1" />
                                                <span>Học không giới hạn</span>
                                            </li>
                                            <li className="flex items-start text-gray-300">
                                                <CheckOutlined className="text-purple-400 mr-2 mt-1" />
                                                <span>Thời hạn: 1825 ngày</span>
                                            </li>
                                            <li className="flex items-start text-gray-300">
                                                <CheckOutlined className="text-purple-400 mr-2 mt-1" />
                                                <span className="font-semibold text-purple-400">Giá trị lâu dài nhất!</span>
                                            </li>
                                        </ul>
                                        <Button
                                            type="primary"
                                            size="large"
                                            block
                                            className="bg-purple-500 hover:bg-purple-600 border-none h-12 text-lg font-semibold"
                                            onClick={() => {
                                                setPricePackage("1400000");
                                                setIsModalOpen(true);
                                            }}
                                        >
                                            Chọn gói này
                                        </Button>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                    )}

                    {transfer?.data?.length > 0 && (
                        <Col
                            lg={20}
                            xs={24}
                            className="p-[20px] mt-5 border border-white/10 rounded bg-[#0f1e35]"
                        >
                            <p className="font-bold py-5 text-center text-xl text-white">Lệnh chuyển tiền</p>
                            <Table
                                className={"custom-table pb-10"}
                                rowKey={(record) => record?.transfer_id + ""}
                                dataSource={transfer?.data}
                                columns={columns}
                                pagination={false}
                            />
                            <Pagination
                                className="flex justify-center"
                                current={pagination.page}
                                total={transfer?.total}
                                pageSize={pagination.pageSize}
                                onChange={(p) => {
                                    setPagination({
                                        page: p,
                                        pageSize: pagination.pageSize
                                    })
                                }}
                            />
                        </Col>
                    )}


                    <Col
                        lg={20}
                        xs={24}
                        className="p-[20px] mt-5 border border-white/10 rounded bg-[#0f1e35]"
                    >
                        <p className="font-bold py-5 text-center text-xl text-white">Thời gian học</p>

                        {/*<Progress className="flex justify-center py-5 font-bold" type="circle" percent={66}/>*/}
                        <Row className="text-center">
                            <Col
                                xs={24} xl={6}
                            >
                                <div className="bg-[#1a2d4a] border border-white/10 p-4 m-2 rounded-xl">
                                    <p className="font-semibold text-lg text-gray-300">Streak hiện tại</p>
                                    <p className="font-semibold text-2xl text-white">{streak?.current_streak}</p>
                                </div>
                            </Col>
                            <Col
                                xs={24} xl={6}
                            >
                                <div className="bg-[#1a2d4a] border border-white/10 p-4 m-2 rounded-xl">
                                    <p className="font-semibold text-lg text-gray-300">Streak dài nhất</p>
                                    <p className="font-semibold text-2xl text-white">{streak?.longest_streak}</p>
                                </div>
                            </Col>
                            <Col
                                xs={24} xl={6}
                            >
                                <div className="bg-[#1a2d4a] border border-white/10 p-4 m-2 rounded-xl">
                                    <p className="font-semibold text-lg text-gray-300">Bản ghi âm</p>
                                    <p className="font-semibold text-2xl text-white">{streak?.total_records}</p>
                                </div>
                            </Col>
                            <Col
                                xs={24} xl={6}
                            >
                                <div className="bg-[#1a2d4a] border border-white/10 p-4 m-2 rounded-xl">
                                    <p className="font-semibold text-lg text-gray-300">Chính xác</p>
                                    <p className="font-semibold text-2xl text-white">{streak?.total_records !== 0 ? Math.floor(streak?.points / streak?.total_records) : 0}</p>
                                </div>
                            </Col>
                            <Col
                                xs={24} xl={6}
                            >
                                <div className="bg-[#1a2d4a] border border-white/10 p-4 m-2 rounded-xl">
                                    <p className="font-semibold text-lg text-gray-300">Tuần này</p>
                                    <p className="font-semibold text-2xl text-white">
                                        {
                                            streak?.this_week
                                                ? Math.floor(streak?.this_week % 86400 / 3600) + "h " + Math.floor(streak?.this_week % 86400 % 3600 / 60) + "m " + Math.floor(streak?.this_week % 86400 % 3600 % 60) + "s"
                                                : "0h 0m 0s"
                                        }
                                    </p>
                                </div>
                            </Col>
                            <Col
                                xs={24} xl={6}
                            >
                                <div className="bg-[#1a2d4a] border border-white/10 p-4 m-2 rounded-xl">
                                    <p className="font-semibold text-lg text-gray-300">Tháng này</p>
                                    <p className="font-semibold text-2xl text-white">
                                        {
                                            streak?.this_month
                                                ? Math.floor(streak?.this_month % 86400 / 3600) + "h " + Math.floor(streak?.this_month % 86400 % 3600 / 60) + "m " + Math.floor(streak?.this_month % 86400 % 3600 % 60) + "s"
                                                : "0h 0m 0s"
                                        }
                                    </p>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                    {enrolls.length > 0 && (
                        <Col
                            lg={20}
                            xs={24}
                            className="p-[20px] mt-5 border border-white/10 rounded bg-[#0f1e35]"
                        >
                            <p className="font-bold py-5 text-center text-xl text-white">Lịch sử bài đã học</p>
                            <Table
                                className={"custom-table pb-10"}
                                rowKey={(record, index) => index + ""}
                                dataSource={enrolls}
                                columns={enrollColumn}
                                pagination={false}
                            />

                        </Col>
                    )}
                </Row>
                <Modal
                    title="Update Vip"
                    style={{
                        top: 50,
                    }}
                    open={isModalOpen}
                    onOk={postTransfer}
                    onCancel={() => setIsModalOpen(false)}
                    okText="Money transferred"
                    okButtonProps={{className: "bg-blue-500"}}
                >
                    <p>Select package:</p>
                    <Select
                        style={{
                            width: 200,
                        }}
                        defaultValue={"choose Package"}
                        onChange={(i) => setPricePackage(i)}
                        options={[
                            {
                                value: "80000",
                                label: '1 month',
                            },
                            {
                                value: "600000",
                                label: '1 year',
                            },
                            {
                                value: "1400000",
                                label: '5 year',
                            },
                        ]}
                    />
                    {handleProvinceChange(pricePackage)}
                </Modal>
            </div>
            {Footer()}
        </>
    );
}
